/* TelaPersonalizzata — UI dedicata Cuscino V1
 * Candidato DRAFT: non pubblicare senza GO Direzione unica.
 * Dipendenza: tp-configuratore-v8.js.
 */
(function () {
  'use strict';

  const ROOT_ID = 'tp-v8-app';
  const CUSHION_KEY = 'cushion';
  const COLORS = new Set(['Bianco', 'Arancione', 'Azzurro', 'Blue', 'Giallo', 'Nero', 'Rosa', 'Rosso']);

  function byId(id) { return document.getElementById(id); }
  function setText(element, value) {
    if (element && element.textContent !== value) element.textContent = value;
  }

  function selectedProductKey() {
    const select = byId('tpv8-product');
    return select ? select.value : '';
  }

  function selectedColor() {
    const root = byId(ROOT_ID);
    if (!root) return '';
    const select = root.querySelector('#tpv8-variant-controls select');
    if (select) {
      const option = select.selectedOptions && select.selectedOptions[0];
      const value = ((option && option.textContent) || select.value || '').trim();
      for (const color of COLORS) if (value.toLowerCase().includes(color.toLowerCase())) return color;
    }
    const pressed = root.querySelector('#tpv8-variant-controls button[aria-pressed="true"]');
    if (pressed) {
      const value = (pressed.textContent || pressed.getAttribute('aria-label') || '').trim();
      for (const color of COLORS) if (value.toLowerCase().includes(color.toLowerCase())) return color;
    }
    const checked = root.querySelector('#tpv8-variant-controls input:checked');
    if (checked) {
      const label = root.querySelector('label[for="' + CSS.escape(checked.id) + '"]');
      const value = (label ? label.textContent : checked.value || '').trim();
      for (const color of COLORS) if (value.toLowerCase().includes(color.toLowerCase())) return color;
    }
    return '';
  }

  function ensureNativeUploadTrigger() {
    const input = byId('tpv8-image-upload');
    const current = byId('tpv8-upload-trigger');
    if (!input || !current || current.tagName === 'LABEL') return;

    const label = document.createElement('label');
    label.id = 'tpv8-upload-trigger';
    label.className = current.className;
    label.htmlFor = input.id;
    label.setAttribute('role', 'button');
    label.tabIndex = 0;
    const describedBy = current.getAttribute('aria-describedby');
    if (describedBy) label.setAttribute('aria-describedby', describedBy);
    while (current.firstChild) label.appendChild(current.firstChild);
    label.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      input.click();
    });

    current.id = 'tpv8-upload-trigger-core';
    current.hidden = true;
    current.setAttribute('aria-hidden', 'true');
    current.tabIndex = -1;
    current.insertAdjacentElement('beforebegin', label);

    // iOS/WebKit gestisce in modo piu affidabile il selettore Foto quando
    // l'input file resta nel DOM accessibile ed e attivato dal relativo label.
    input.hidden = false;
    input.classList.add('tpv8-cushion-file-input-native');
    input.setAttribute('aria-hidden', 'true');
    input.tabIndex = -1;
  }

  function restoreSharedUploadTrigger() {
    const input = byId('tpv8-image-upload');
    const label = byId('tpv8-upload-trigger');
    const original = byId('tpv8-upload-trigger-core');
    if (!original) return;
    if (label && label.tagName === 'LABEL') label.remove();
    original.id = 'tpv8-upload-trigger';
    original.hidden = false;
    original.removeAttribute('aria-hidden');
    original.removeAttribute('tabindex');
    if (input) {
      input.classList.remove('tpv8-cushion-file-input-native');
      input.removeAttribute('aria-hidden');
      input.removeAttribute('tabindex');
      input.hidden = true;
    }
  }

  function ensureDirectTextFlow(root) {
    const stage = root.querySelector('.tpv8-canvas-stage');
    const coreInput = byId('tpv8-text');
    const coreAdd = byId('tpv8-add-text');
    if (!stage || !coreInput || !coreAdd) return;

    let directControls = byId('tpv8-cushion-direct-controls');
    if (!directControls) {
      directControls = document.createElement('div');
      directControls.id = 'tpv8-cushion-direct-controls';
      directControls.className = 'tpv8-cushion-direct-controls';
      directControls.hidden = true;
      stage.insertAdjacentElement('beforeend', directControls);
    }

    if (!directControls.dataset.tpv8PointerGuard) {
      directControls.dataset.tpv8PointerGuard = 'true';
      directControls.addEventListener('pointerdown', function (event) {
        event.stopPropagation();
      });
      directControls.addEventListener('touchstart', function (event) {
        event.stopPropagation();
      }, { passive: true });
    }

    let action = byId('tpv8-cushion-canvas-text-action');
    if (!action) {
      action = document.createElement('button');
      action.type = 'button';
      action.id = 'tpv8-cushion-canvas-text-action';
      action.className = 'tpv8-cushion-canvas-text-action';
      action.innerHTML = '<span aria-hidden="true">＋</span><strong>Aggiungi scritta</strong>';
      directControls.appendChild(action);
    }

    let styleDrawer = byId('tpv8-cushion-inline-style');
    if (!styleDrawer) {
      styleDrawer = document.createElement('div');
      styleDrawer.id = 'tpv8-cushion-inline-style';
      styleDrawer.className = 'tpv8-cushion-inline-style';
      styleDrawer.hidden = true;
      styleDrawer.innerHTML = '<label for="tpv8-cushion-inline-font">Font</label><select id="tpv8-cushion-inline-font" aria-label="Font della scritta"><option value="Arial">Arial</option><option value="Georgia">Georgia</option><option value="Montserrat">Montserrat</option></select><label for="tpv8-cushion-inline-color">Colore</label><input id="tpv8-cushion-inline-color" type="color" value="#0b2a3a" aria-label="Colore della scritta"><button type="button" data-tpv8-cushion-smaller aria-label="Riduci la scritta">A−</button><button type="button" data-tpv8-cushion-larger aria-label="Ingrandisci la scritta">A＋</button>';
      directControls.appendChild(styleDrawer);

      const directFont = byId('tpv8-cushion-inline-font');
      const directColor = byId('tpv8-cushion-inline-color');
      directFont.addEventListener('change', function () {
        const option = Array.from(byId('tpv8-font-menu')?.querySelectorAll('.tpv8-font-option') || []).find(function (button) {
          return button.dataset.font === directFont.value;
        });
        if (option) option.click();
      });
      directColor.addEventListener('change', function () {
        const coreColor = byId('tpv8-text-color');
        if (!coreColor) return;
        coreColor.value = directColor.value;
        coreColor.dispatchEvent(new Event('change', { bubbles: true }));
      });
      styleDrawer.querySelector('[data-tpv8-cushion-smaller]').addEventListener('click', function () {
        byId('tpv8-text-smaller')?.click();
      });
      styleDrawer.querySelector('[data-tpv8-cushion-larger]').addEventListener('click', function () {
        byId('tpv8-text-larger')?.click();
      });
    }

    let bar = byId('tpv8-cushion-inline-text');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'tpv8-cushion-inline-text';
      bar.className = 'tpv8-cushion-inline-text';
      bar.hidden = true;
      bar.innerHTML = '<label for="tpv8-cushion-inline-text-input">Scritta sul cuscino</label><input id="tpv8-cushion-inline-text-input" type="text" maxlength="180" autocomplete="off" placeholder="Scrivi qui"><button type="button" data-tpv8-cushion-style aria-label="Stile della scritta" aria-expanded="false" aria-controls="tpv8-cushion-inline-style">Aa</button><button type="button" data-tpv8-cushion-text-done aria-label="Fine modifica scritta">✓</button>';
      directControls.appendChild(bar);

      const directInput = byId('tpv8-cushion-inline-text-input');
      let updateTimer = 0;
      directInput.addEventListener('input', function () {
        coreInput.value = directInput.value;
        clearTimeout(updateTimer);
        updateTimer = setTimeout(function () {
          coreInput.dispatchEvent(new Event('change', { bubbles: true }));
        }, 120);
      });
      directInput.addEventListener('change', function () {
        clearTimeout(updateTimer);
        coreInput.value = directInput.value;
        coreInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      bar.querySelector('[data-tpv8-cushion-style]').addEventListener('click', function () {
        const drawer = byId('tpv8-cushion-inline-style');
        const coreFontButton = byId('tpv8-font-button');
        const coreFontMenu = byId('tpv8-font-menu');
        const directFont = byId('tpv8-cushion-inline-font');
        if (!drawer || !coreFontButton || !coreFontMenu || !directFont) return;
        if (!coreFontMenu.querySelector('.tpv8-font-option')) coreFontButton.click();
        const fonts = Array.from(coreFontMenu.querySelectorAll('.tpv8-font-option')).map(function (button) {
          return button.dataset.font;
        }).filter(Boolean);
        if (fonts.length) {
          directFont.textContent = '';
          fonts.forEach(function (font) {
            const option = document.createElement('option');
            option.value = font;
            option.textContent = font;
            directFont.appendChild(option);
          });
        }
        coreFontMenu.hidden = true;
        coreFontButton.setAttribute('aria-expanded', 'false');
        directFont.value = byId('tpv8-font-value')?.value || 'Arial';
        const open = drawer.hidden;
        drawer.hidden = !open;
        this.setAttribute('aria-expanded', String(open));
      });
      bar.querySelector('[data-tpv8-cushion-text-done]').addEventListener('click', function () {
        if (!directInput.value.trim()) {
          coreInput.value = '';
          const deleteButton = byId('tpv8-delete');
          if (deleteButton) deleteButton.click();
        }
        root.dataset.tpv8CushionTextClosed = 'true';
        directInput.blur();
        bar.hidden = true;
        const drawer = byId('tpv8-cushion-inline-style');
        if (drawer) drawer.hidden = true;
      });
    }

    if (!action.dataset.tpv8Bound) {
      action.dataset.tpv8Bound = 'true';
      action.addEventListener('click', function () {
        delete root.dataset.tpv8CushionTextClosed;
        coreInput.value = '\u200c';
        coreAdd.click();
        const directInput = byId('tpv8-cushion-inline-text-input');
        if (!directInput) return;
        directInput.value = '';
        requestAnimationFrame(function () {
          directInput.focus({ preventScroll: true });
          directInput.select();
        });
      });
    }

    const directInput = byId('tpv8-cushion-inline-text-input');
    const editing = byId('tpv8-text-tools')?.classList.contains('is-editing');
    directControls.hidden = !root.classList.contains('tpv8-has-image');
    [action, bar, styleDrawer].forEach(function (control) {
      if (control.parentElement !== directControls) directControls.appendChild(control);
    });
    bar.hidden = !editing || root.dataset.tpv8CushionTextClosed === 'true';
    if (editing && directInput && document.activeElement !== directInput) directInput.value = coreInput.value;
    if (!editing || root.dataset.tpv8CushionTextClosed === 'true') styleDrawer.hidden = true;
    if (editing) {
      const directFont = byId('tpv8-cushion-inline-font');
      const directColor = byId('tpv8-cushion-inline-color');
      if (directFont && Array.from(directFont.options).some(function (option) { return option.value === byId('tpv8-font-value')?.value; })) {
        directFont.value = byId('tpv8-font-value').value;
      }
      if (directColor && byId('tpv8-text-color')) directColor.value = byId('tpv8-text-color').value;
    }

    const canvas = byId('tpv8-canvas');
    if (canvas && !canvas.dataset.tpv8CushionDirectText) {
      canvas.dataset.tpv8CushionDirectText = 'true';
      canvas.addEventListener('pointerup', function () {
        requestAnimationFrame(function () {
          if (selectedProductKey() !== CUSHION_KEY) return;
          if (!byId('tpv8-text-tools')?.classList.contains('is-editing')) return;
          delete root.dataset.tpv8CushionTextClosed;
          ensureDirectTextFlow(root);
        });
      });
    }
  }

  function restoreDirectTextFlow(root) {
    const action = byId('tpv8-cushion-canvas-text-action');
    if (action) action.remove();
    const bar = byId('tpv8-cushion-inline-text');
    if (bar) bar.remove();
    const styleDrawer = byId('tpv8-cushion-inline-style');
    if (styleDrawer) styleDrawer.remove();
    const directControls = byId('tpv8-cushion-direct-controls');
    if (directControls) directControls.remove();
    delete root.dataset.tpv8CushionTextClosed;
  }

  function ensureCushionCopy(root) {
    ensureNativeUploadTrigger();
    ensureDirectTextFlow(root);
    const title = root.querySelector('.tpv8-topbar h1');
    const intro = root.querySelector('.tpv8-topbar h1 + p');
    const canvasLabel = root.querySelector('.tpv8-canvas-label');
    const detail = byId('tpv8-product-detail');
    const textQuestion = root.querySelector('.tpv8-text-question');
    const variantHeading = root.querySelector('#tpv8-panel-variant h3');

    let compactHead = byId('tpv8-cushion-compact-head');
    if (!compactHead) {
      compactHead = document.createElement('header');
      compactHead.id = 'tpv8-cushion-compact-head';
      compactHead.className = 'tpv8-cushion-compact-head';
      compactHead.innerHTML = '<strong>TelaPersonalizzata</strong><span id="tpv8-cushion-head-price">—</span>';
      root.insertBefore(compactHead, root.firstChild);
    }
    const livePrice = byId('tpv8-price');
    const headPrice = byId('tpv8-cushion-head-price');
    if (livePrice && headPrice) setText(headPrice, livePrice.textContent);

    setText(title, 'Crea il tuo cuscino');
    setText(intro, 'Carica una foto, sistemala e aggiungi una scritta se vuoi.');
    setText(canvasLabel, 'Area stampabile 36 × 36 cm');
    setText(detail, 'Area di stampa 36 × 36 cm');
    setText(textQuestion, 'Vuoi aggiungere una scritta? (facoltativo)');
    if (variantHeading && !variantHeading.dataset.tpv8CushionCopy) {
      const step = variantHeading.querySelector('.tpv8-step');
      variantHeading.textContent = '';
      if (step) variantHeading.appendChild(step);
      variantHeading.appendChild(document.createTextNode('Colore del resto del cuscino'));
      variantHeading.dataset.tpv8CushionCopy = 'true';
    }

    let note = byId('tpv8-cushion-color-note');
    if (!note) {
      note = document.createElement('p');
      note.id = 'tpv8-cushion-color-note';
      note.className = 'tpv8-cushion-color-note';
      const controls = byId('tpv8-variant-controls');
      if (controls) controls.insertAdjacentElement('afterend', note);
    }
    if (note) {
      const color = selectedColor();
      setText(note, color
        ? 'La foto copre l’area stampabile. ' + color + ' resta visibile sul resto del cuscino.'
        : 'Il colore scelto riguarda solo il resto del cuscino, non la fotografia.');
    }

    const textToggle = byId('tpv8-text-toggle');
    setText(textToggle, 'Aggiungi una scritta facoltativa');
    const upload = byId('tpv8-upload-trigger');
    if (upload) {
      const strong = upload.querySelector('strong');
      if (strong && !root.classList.contains('tpv8-has-image')) setText(strong, 'Scegli una foto');
    }

    let tabs = byId('tpv8-cushion-tabs');
    if (!tabs) {
      tabs = document.createElement('div');
      tabs.id = 'tpv8-cushion-tabs';
      tabs.className = 'tpv8-cushion-tabs';
      tabs.innerHTML = '<button type="button" data-tpv8-cushion-tab="photo" aria-pressed="true">Foto</button><button type="button" data-tpv8-cushion-tab="text" aria-pressed="false">Scritta facoltativa</button>';
      const photoPanel = byId('tpv8-panel-photo');
      if (photoPanel) photoPanel.insertAdjacentElement('beforebegin', tabs);
      tabs.addEventListener('click', function (event) {
        const button = event.target.closest('[data-tpv8-cushion-tab]');
        if (!button) return;
        const choice = button.dataset.tpv8CushionTab;
        tabs.querySelectorAll('button').forEach(function (candidate) {
          candidate.setAttribute('aria-pressed', String(candidate === button));
        });
        root.dataset.tpv8CushionPanel = choice;
        if (choice === 'text') {
          if (matchMedia('(max-width: 860px)').matches) {
            root.dataset.tpv8CushionPanel = 'photo';
            tabs.querySelectorAll('button').forEach(function (candidate) {
              candidate.setAttribute('aria-pressed', String(candidate.dataset.tpv8CushionTab === 'photo'));
            });
            byId('tpv8-cushion-canvas-text-action')?.click();
            return;
          }
          const toggle = byId('tpv8-text-toggle');
          const tools = byId('tpv8-text-tools');
          if (toggle && tools && tools.hidden) toggle.click();
        }
      });
    }
    if (!root.dataset.tpv8CushionPanel) root.dataset.tpv8CushionPanel = 'photo';
  }

  function restoreSharedCopy(root) {
    restoreSharedUploadTrigger();
    restoreDirectTextFlow(root);
    const title = root.querySelector('.tpv8-topbar h1');
    const intro = root.querySelector('.tpv8-topbar h1 + p');
    const canvasLabel = root.querySelector('.tpv8-canvas-label');
    setText(title, 'Crea il tuo prodotto in tre passaggi');
    setText(intro, 'Scegli, carica la foto e controlla il risultato: il passo successivo è sempre indicato.');
    setText(canvasLabel, 'Area stampabile reale');
    const variantHeading = root.querySelector('#tpv8-panel-variant h3');
    if (variantHeading && variantHeading.dataset.tpv8CushionCopy) {
      const step = variantHeading.querySelector('.tpv8-step');
      variantHeading.textContent = '';
      if (step) variantHeading.appendChild(step);
      variantHeading.appendChild(document.createTextNode('Scegli variante'));
      delete variantHeading.dataset.tpv8CushionCopy;
    }
    setText(root.querySelector('.tpv8-text-question'), 'Vuoi aggiungere una scritta?');
    setText(byId('tpv8-text-toggle'), 'Aggiungi una scritta');
    const note = byId('tpv8-cushion-color-note');
    if (note) note.remove();
    const compactHead = byId('tpv8-cushion-compact-head');
    if (compactHead) compactHead.remove();
    const tabs = byId('tpv8-cushion-tabs');
    if (tabs) tabs.remove();
    root.removeAttribute('data-tpv8-cushion-panel');
  }

  function sync() {
    const root = byId(ROOT_ID);
    if (!root) return;
    const cushion = selectedProductKey() === CUSHION_KEY;
    root.toggleAttribute('data-tpv8-cushion', cushion);
    if (cushion) ensureCushionCopy(root);
    else restoreSharedCopy(root);
  }

  function boot() {
    const root = byId(ROOT_ID);
    if (!root) return;
    let scheduled = false;
    const schedule = function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; sync(); });
    };
    root.addEventListener('change', schedule);
    root.addEventListener('click', schedule);
    new MutationObserver(schedule).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked', 'class'] });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
